import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Upload } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { VIDEO_URL } from "./landing/VideoDemo";

export function VideoBienvenida() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const key = `farmanaliza-bienvenida-${user?.id}`;

  useEffect(() => {
    if (!user?.id || user.role === "admin" || localStorage.getItem(key)) return;
    api.get("/studies").then(({ data }) => { if (!data?.length) setOpen(true); }).catch(() => {});
  }, [user?.id, user?.role, key]);

  const cerrar = () => { localStorage.setItem(key, "1"); setOpen(false); };
  if (!open) return null;

  return (
    <div className="fixed inset-0 w-screen h-screen z-[60] bg-[#0b1f3f] text-white flex flex-col fade-in" data-testid="video-bienvenida">
      <div className="flex items-start justify-between gap-4 px-5 sm:px-10 pt-6">
        <div>
          <div className="text-xs font-semibold uppercase tracking-widest text-sky-300">Bienvenida</div>
          <h2 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight mt-1">Te damos la bienvenida a Farmanaliza{user?.pharmacy_name ? `, ${user.pharmacy_name}` : ""}</h2>
          <p className="text-blue-100/80 text-sm sm:text-base mt-1">Mira este vídeo para sacar partido a la app desde el primer día.</p>
        </div>
        <button onClick={cerrar} aria-label="Cerrar" className="shrink-0 p-2 rounded-full hover:bg-white/10 transition-colors" data-testid="video-bienvenida-cerrar"><X size={26} /></button>
      </div>
      <div className="flex-1 min-h-0 flex items-center justify-center px-5 sm:px-10 py-5">
        <video className="max-w-full max-h-full rounded-2xl shadow-2xl bg-black" controls autoPlay playsInline src={VIDEO_URL} data-testid="video-bienvenida-player">
          Tu navegador no puede reproducir este vídeo.
        </video>
      </div>
      <div className="flex flex-wrap items-center justify-center gap-3 px-5 pb-6">
        <Link to="/subidas" onClick={cerrar} className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#1f6fd1] hover:bg-[#1658a8] font-bold transition-colors" data-testid="video-bienvenida-subir">
          <Upload size={17} /> Subir mi primer inventario
        </Link>
        <button onClick={cerrar} className="px-6 py-3 rounded-full border border-white/30 font-semibold hover:bg-white/10 transition-colors" data-testid="video-bienvenida-despues">Verlo más tarde</button>
      </div>
    </div>
  );
}
